import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { editSubadminDataApiCall } from "../../Store/slices/subadminSlice";
import * as API from "../../utils/api.service";
import { Icon } from 'react-icons-kit';
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { eye } from 'react-icons-kit/feather/eye';
import {
  EMAIL_VALIDATION,
  PASSWORD_VALIDATION,
  TEXT_WITH_SPACE_VALIDATION,
  MOBILE_VALIDATION,
  TOAST_ERROR,
  DecryptPassword,
} from "../../utils/common.service";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function EditSubAdmin() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const clientData = location?.state?.clientData;
  const [permissions, setPermissions] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    getValues,
  } = useForm();

  useEffect(() => {
    const fetchPermission = async () => {
      try {
        dispatch(setLoader(true));
        const response = await API.getpermissionApi({ id: clientData?.id });
        console.log("All permission Api response", response);
        setPermissions(response.data);

        // Set initial permission values based on the API response
        response.data.forEach((permission) => {
          setValue(
            `permissions.${permission.name}.add`,
            !!permission.permission_add
          );
          setValue(
            `permissions.${permission.name}.update`,
            !!permission.permission_update
          );
          setValue(
            `permissions.${permission.name}.delete`,
            !!permission.permission_delete
          );
          setValue(
            `permissions.${permission.name}.view`,
            !!permission.permission_view
          );
        });

        dispatch(setLoader(false));
      } catch (error) {
        dispatch(setLoader(false));
        TOAST_ERROR("Failed to load User Details");
      }
    };

    fetchPermission();
  }, [dispatch, clientData?.id, setValue]);

const setData = async () => {
    try {
      const decpassword = await DecryptPassword(clientData?.password);
      // console.log('clientData :', clientData);
      // console.log('decpassword :', decpassword);
      
      // Remove any surrounding quotes if they exist
      const cleanedPassword = decpassword ? decpassword.replace(/^"|"$/g, '') : "";
      
      console.log('Decrypted password:', cleanedPassword);

      reset({
        name: clientData?.name || "",
        email: clientData?.email || "",
        phone: clientData?.phone || "",
        password: cleanedPassword,
      });
    } catch (error) {
      //console.error("Decryption failed:", error);
      TOAST_ERROR("Failed to decrypt password. Please try again.");
    }
};

  useEffect(() => {
    if (clientData) {
      setData();
    }
  }, [clientData, reset]);

  // Handle Select All Permissions
  const handleSelectAllPermissions = (isChecked) => {
    permissions.forEach((permission) => {
      setValue(`permissions.${permission.name}.add`, isChecked);
      setValue(`permissions.${permission.name}.update`, isChecked);
      setValue(`permissions.${permission.name}.delete`, isChecked);
      setValue(`permissions.${permission.name}.view`, isChecked);
      document.getElementById(`select-all-${permission.name}`).checked = isChecked;
    });
  };

  // Handle Select All Permissions for a Specific permission
  const handleSelectModulePermissions = (permissionName, isChecked) => {
    setValue(`permissions.${permissionName}.view`, isChecked); // Always check the view permission first
    setValue(`permissions.${permissionName}.add`, isChecked);
    setValue(`permissions.${permissionName}.update`, isChecked);
    setValue(`permissions.${permissionName}.delete`, isChecked);
  };

  const onSubmit = async (submitData) => {
    try {
      dispatch(setLoader(true));

      // Check the structure of the submitData
     // console.log("Submitted Data:", submitData);

      let updatePermission = {
        id: clientData?.id,
        permissions: permissions.map((permission) => ({
          module_id: permission.module_id,
          permission_add: submitData?.permissions?.[permission.name]?.add
            ? 1
            : 0,
          permission_update: submitData?.permissions?.[permission.name]?.update
            ? 1
            : 0,
          permission_delete: submitData?.permissions?.[permission.name]?.delete
            ? 1
            : 0,
          permission_view: submitData?.permissions?.[permission.name]?.view
            ? 1
            : 0,
        })),
      };

      // Log request body before making API call
      //console.log("Request body:", updatePermission);

      // Send updated permissions to API
      const response = await API.updatePermissionApi(updatePermission);
      //const response =0;

      if (response.code == 1) {
        let requestBody = {
          id: clientData?.id,
          name: submitData.name,
          email: submitData.email,
          phone: submitData.phone,
          password: submitData.password,
        };
        dispatch(editSubadminDataApiCall(requestBody));
        navigate(`/manage_subadmin`);
        reset();
        dispatch(setLoader(false));
      }
    } catch (err) {
      TOAST_ERROR(err.message);
      dispatch(setLoader(false));
    }
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar
            title={`Edit Sub Admin`}
            header={`sub admin`}
            subHeader={`Edit Sub Admin`}
          />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="d-flex justify-content-lg-start">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => navigate(-1)}
                >
                  <IoMdArrowRoundBack fontSize={"20px"}/>
                </button>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      placeholder="Enter name"
                      {...register("name", TEXT_WITH_SPACE_VALIDATION("name"))}
                    />
                    <div className="errorc">{errors.name?.message}</div>
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="text"
                      id="email"
                      className="form-control"
                      placeholder="Enter email"
                      {...register("email", EMAIL_VALIDATION())}
                    />
                    <div className="errorc">{errors.email?.message}</div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="phone" className="form-label">
                      Phone No
                    </label>
                    <input
                      type="text"
                      id="phone"
                      className="form-control"
                      placeholder="Enter phone number"
                      {...register("phone", MOBILE_VALIDATION())}
                    />
                    <div className="errorc">{errors.phone?.message}</div>
                  </div>

                  <div className="col-md-6">
                  <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <div className="position-relative">
                          <input
                            className="form-control"
                            type={showPassword ? "text" : "password"}
                            id="password"
                            placeholder="Enter your password"
                            {...register("password", PASSWORD_VALIDATION())}
                            aria-invalid={errors.password ? "true" : "false"}
                          />
                          <span
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Icon
                              icon={showPassword ? eye : eyeOff}
                              size={20}
                            />
                          </span>
                        </div>
                        <label className="errorc">
                          {errors.password?.message}
                        </label>
                  </div>
                </div>

                <div className="container mt-4">
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <h5 className="mb-3">Module Permissions</h5>
                      {/* Select all permissions button */}
                      <div className="form-check mb-4">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="select-all-permissions"
                          onChange={(e) =>
                            handleSelectAllPermissions(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="select-all-permissions"
                        >
                          Give All Permissions
                        </label>
                      </div>

                      {permissions.length > 0 ? (
                        permissions.map((permission, index) => (
                          <div key={index} className="card mb-3">
                            <div className="card-body">
                              <h4 className="card-title d-flex align-items-center">
                                {permission.name}
                              </h4>

                              {/* permission Permissions */}
                              <div className="d-flex align-items-center">
                                <div className="form-check me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`select-all-${permission.name}`}
                                    onChange={(e) =>
                                      handleSelectModulePermissions(
                                        permission.name,
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`select-all-${permission.name}`}
                                  >
                                    All
                                  </label>
                                </div>
                                <div className="form-check me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`view-${permission.name}`}
                                    {...register(
                                      `permissions.${permission.name}.view`
                                    )}
                                    onChange={(e) => {
                                      // Use getValues to fetch the current state of other permissions
                                      const addChecked = getValues(
                                        `permissions.${permission.name}.add`
                                      );
                                      const updateChecked = getValues(
                                        `permissions.${permission.name}.update`
                                      );
                                      const deleteChecked = getValues(
                                        `permissions.${permission.name}.delete`
                                      );

                                      // Only allow unchecking view if no other permissions are checked
                                      if (
                                        !addChecked &&
                                        !updateChecked &&
                                        !deleteChecked
                                      ) {
                                        setValue(
                                          `permissions.${permission.name}.view`,
                                          e.target.checked
                                        );
                                      } else {
                                        setValue(
                                          `permissions.${permission.name}.view`,
                                          true
                                        ); // Prevent unchecking if other permissions are selected
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`view-${permission.name}`}
                                  >
                                    View
                                  </label>
                                </div>

                                <div className="form-check me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`add-${permission.name}`}
                                    {...register(
                                      `permissions.${permission.name}.add`
                                    )}
                                    onChange={(e) => {
                                      setValue(
                                        `permissions.${permission.name}.add`,
                                        e.target.checked
                                      );
                                      if (e.target.checked) {
                                        setValue(
                                          `permissions.${permission.name}.view`,
                                          true
                                        );
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`add-${permission.name}`}
                                  >
                                    Add
                                  </label>
                                </div>

                                <div className="form-check me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`update-${permission.name}`}
                                    {...register(
                                      `permissions.${permission.name}.update`
                                    )}
                                    onChange={(e) => {
                                      setValue(
                                        `permissions.${permission.name}.update`,
                                        e.target.checked
                                      );
                                      if (e.target.checked) {
                                        setValue(
                                          `permissions.${permission.name}.view`,
                                          true
                                        ); // Ensure view is checked
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`update-${permission.name}`}
                                  >
                                    Update
                                  </label>
                                </div>

                                <div className="form-check me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`delete-${permission.name}`}
                                    {...register(
                                      `permissions.${permission.name}.delete`
                                    )}
                                    onChange={(e) => {
                                      setValue(
                                        `permissions.${permission.name}.delete`,
                                        e.target.checked
                                      );
                                      if (e.target.checked) {
                                        setValue(
                                          `permissions.${permission.name}.view`,
                                          true
                                        ); // Ensure view is checked
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`delete-${permission.name}`}
                                  >
                                    Delete
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>Loading permissions...</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="mb-0 text-center">
                  <button className="btn btn-soft-primary w-25" type="submit">
                    <i className="ri-save-fill"></i>
                    <span className="fw-bold">Update</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
